import React from 'react'
import { Link } from 'react-router-dom'
import Button from '../../../components/Button/Button'
import Skeleton from 'react-loading-skeleton'

const Profiledetails = ({ isActiveTab, handleClickEditProfile, data, isFetching }) => {
    return (
        <div className={`ContainerTabForAllTabData tabWrapper ${isActiveTab && 'active'}`}>
            <div className="Headingforallheader slotdetailsfixpd">
                <div className="flex-between w-100">
                    <h2 className="heading-2">Profile Details</h2>
                    <Button name={'Edit Profile'} className="BlueFillButton" onClick={handleClickEditProfile} />
                </div>
            </div>

            <div className="border-btm w-100"></div>

            <div className="bodyDataForallUserdata Adfixwidthalldata">
                <div className="profileDetailsWrap">
                    <div className="profileDetails flexbox">
                        <div className="profileOptions Addatasetwidth">
                            {isFetching ? <Skeleton width={"100px"} /> : 'First Name'}
                        </div>
                        <div className="profileData AdAnssetwidth">
                        {isFetching ? <Skeleton width={"100px"} /> : data?.firstName ? data?.firstName : "---"}
                        </div>
                    </div>
                    <div className="profileDetails flexbox">
                        <div className="profileOptions Addatasetwidth">
                            {isFetching ? <Skeleton width={"100px"} /> : 'Last Name'}
                        </div>
                        <div className="profileData AdAnssetwidth">
                        {isFetching ? <Skeleton width={"100px"} /> : data?.lastName ? data?.lastName : "---"}
                        </div>
                    </div>
                    <div className="profileDetails flexbox">
                        <div className="profileOptions Addatasetwidth">
                            {isFetching ? <Skeleton width={"100px"} /> : 'Designation'}
                        </div>
                        <div className="profileData AdAnssetwidth">
                        {isFetching ? <Skeleton width={"100px"} /> : data?.profession?.designation ? data?.profession?.designation : "---"}
                        </div>
                    </div>
                    <div className="profileDetails flexbox">
                        <div className="profileOptions Addatasetwidth">
                        {isFetching ? <Skeleton width={"100px"} /> : 'Current Company'}
                        </div>
                        <div className="profileData AdAnssetwidth">
                        {isFetching ? <Skeleton width={"100px"} /> : data?.profession?.company ? data?.profession?.company : "---"}
                        </div>
                    </div>

                    <div className="profileDetails flexbox">
                        <div className="profileOptions Addatasetwidth">
                            {isFetching ? <Skeleton width={"100px"} /> : 'Phone Number'}
                        </div>
                        <div className="profileData AdAnssetwidth">
                            {isFetching ? <Skeleton width={"100px"} /> : data?.mobileNumber ? data?.mobileNumber : "---"}
                        </div>
                    </div>
                    <div className="profileDetails flexbox">
                        <div className="profileOptions Addatasetwidth">
                            {isFetching ? <Skeleton width={"100px"} /> : 'Email'}
                        </div>
                        <div className="profileData AdAnssetwidth">
                            {isFetching ? <Skeleton width={"100px"} /> : data?.email ? data?.email : "---"}
                        </div>
                    </div>
                    <div className="profileDetails flexbox">
                        <div className="profileOptions Addatasetwidth">
                            {isFetching ? <Skeleton width={"100px"} /> : 'Linkedin'}
                        </div>
                        <div className="profileData AdAnssetwidth">
                            {isFetching ? <Skeleton width={"200px"} /> : data?.linkedin ? <a className='SocialLink' target='_blank' href={data?.linkedin.slice(0,4) === "http" ? data?.linkedin : "https://" + data?.linkedin} rel='noreferrer'>
                                {data?.linkedin}
                            </a> : <span>{"---"}</span>}
                        </div>
                    </div>
                    <div className="dashedDivider"></div>

                    <div className="profileDetails flexbox">
                        <div className="profileOptions Addatasetwidth">
                            {isFetching ? <Skeleton width={"100px"} /> : 'About'}
                        </div>
                        <div className="profileData AdAnssetwidth">
                            {isFetching ? <Skeleton width={"400px"} /> : data?.about ? data?.about : "---"}
                        </div>
                    </div>

                    <div className="profileDetails flexbox">
                        <div className="profileOptions Addatasetwidth">
                            {isFetching ? <Skeleton width={"100px"} /> : 'Years of Experience'}
                        </div>
                        <div className="profileData AdAnssetwidth">
                            {isFetching ? <Skeleton width={"100px"} /> : data?.profession?.yrsOfExp ? `${data?.profession?.yrsOfExp}+ years` : "---"}
                        </div>
                    </div>

                    <div className="profileDetails flexbox">
                        <div className="profileOptions Addatasetwidth">
                            {isFetching ? <Skeleton width={"100px"} /> : 'Functional focus area'}
                        </div>
                        <div className="profileData AdAnssetwidth">
                            <div className="dataexpertise">
                                {isFetching ? <Skeleton width={"100px"} /> : data?.interests?.length > 0 ? data?.interests?.map((item, index) => (
                                    <div className='text2' key={index}>{item?.interest ? item?.interest : "---"}</div>
                                )) : "---"}
                            </div>
                        </div>
                    </div>
                    <div className="profileDetails flexbox">
                        <div className="profileOptions Addatasetwidth">
                            {isFetching ? <Skeleton width={"100px"} /> : 'Mentoring On'}
                        </div>
                        <div className="profileData AdAnssetwidth">
                            <div className="dataexpertise">
                            {isFetching ? <Skeleton width={"100px"} /> : data?.topics?.length > 0 ? data?.topics?.map((item, index) => (
                                    <div className='text2' key={index}>{item?.Topic ? item?.Topic : "---"}</div>
                                )) : "---"}
                            </div>
                        </div>
                    </div>

                </div>

            </div>

        </div>
    )
}

export default Profiledetails
